import { useContext } from 'react';
import { SellersContext } from '../contexts/sellersContext';

export default function useSellers() {
    return useContext(SellersContext);
}
